import { SxProps, Theme } from "@mui/material/styles";

export const taxColumnsGridSx = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1.1fr) minmax(88px, 0.7fr) minmax(0, 1.4fr) minmax(64px, auto)",
  columnGap: 2,
} as const satisfies SxProps<Theme>;
